import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Container, Box } from '@mui/material'
import clsx from 'clsx'
import { FOOTER_VARIANTS } from '../Sections.const'
import { useFooter } from './Footer.hooks'

const Footer = props => {
	const [{ classes, Element, metaData }] = useFooter(props)

	return (
		<Box className="section-footer">
			<Container className={clsx(classes.container, 'section-footer-content')}>
				{Element && <Element metaData={metaData} />}
			</Container>
		</Box>
	)
}

Footer.propTypes = {
	variant: PropTypes.oneOf(Object.values(FOOTER_VARIANTS)),
	Element: PropTypes.elementType,
}

export default memo(Footer)
